<template>
	<div>
		<v-card>
			<v-card-title>
				<v-text-field
					v-model="searchLocal"
					append-icon="mdi-magnify"
					label="Search"
					single-line
					hide-details
					@input="getDataFromApiSearch"
				></v-text-field>
			</v-card-title>
			<v-data-table
				class="table"
				:headers="computedHeaders"
				:items="itemsVc"
				:items-per-page="100"
				no-data-text="There is no data to this filters"
				item-key="id"
				hide-default-footer
				dense
				:expanded.sync="expanded"
				:options.sync="options"
				:sort-by.sync="sortBy"
				:sortDesc.sync="sortDesc"
				@click:row="clickedRow"
			>
				<!-- format date to date format -->
				<template
					v-for="header in computedHeaders.filter((header) => header.hasOwnProperty('formatter'))"
					v-slot:[`item.${header.value}`]="{ value }"
				>
					{{ header.formatter(value) }}
				</template>
				<!-- expandable table -->
				<template v-slot:expanded-item=" {headers} ">
					<td :colspan="headers.length" class="expandableArea">
						<v-card>
							<v-data-table
								class="validityCheckerDataTable"
								dense
								:headers="computedExpandedHeaders"
								:items="expanded"
								hide-default-footer
								item-key="unique_identifier"
							>
								<template
									v-for="header in computedExpandedHeaders.filter((header) => header.hasOwnProperty('formatter'))"
									v-slot:[`item.${header.value}`]="{ value }"
								>
									{{ header.formatter(value) }}
								</template>
							</v-data-table>
						</v-card>
					</td>
				</template>
			</v-data-table>
		</v-card>

		<!-- last data update -->
		<validity-data-last-updated
			:lastUpdated="lastVcDataUpdateForMandatorLocal"
		/>
	</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import ValidityDataLastUpdated from './ValidityDataLastUpdated.vue'

export default {
	name: 'AccessTransactionReportTable',
	props: {
		itemsVc: { type: Array, required: true },
		// this prop is needed so that the v-data table options
		// init change does not result on sending a not finished object
		doneFirstFetching: { type: Boolean, required: true },
		lastVcDataUpdateForMandator: {},
		search: { type: String },
		hideSpCols: { type: Boolean, required: false, default: false },
		hideGenericUsageKeyCol: { type: Boolean, required: false, default: false },
	},
	components: {
		ValidityDataLastUpdated,
	},
	data() {
		return {
			dateFormat: 'YYYY-MM-DD HH:mm:ss',
			headers:
			[
				{
					value: 'usage_date',
					text: 'Redemption date and time',
					class: 'black-lighten --text',
					align: 'left',
					width: 150,
					formatter: (x) => (x ? moment.parseZone(x).format(this.dateFormat) : null),
				}, {
					value: 'original_contingent',
					text: 'Original Contingent',
					class: 'black-lighten --text',
					width: 125,
					align: 'left',
				},
				{
					value: 'remaining_contingent',
					text: 'Remaining contingent',
					class: 'black-lighten --text',
					sortable: false,
					width: 125,
					align: 'left',
				}, {
					value: 'validity_start_date',
					text: 'Validity Start Date',
					class: 'black-lighten --text',
					align: 'left',
					width: 140,
					formatter: (x) => (x ? moment(x).format(this.dateFormat) : null),
				}, {
					value: 'validity_end_date',
					text: 'Validity End Date',
					class: 'black-lighten --text',
					align: 'left',
					width: 140,
					formatter: (x) => (x ? moment(x).format(this.dateFormat) : null),
				}, {
					value: 'gate_group',
					text: 'Gate Group',
					class: 'black-lighten --text',
					width: 125,
					align: 'left',
				}, {
					value: 'gate',
					text: 'Gate',
					class: 'black-lighten --text',
					width: 115,
					align: 'left',
				}, {
					value: 'buyer_name',
					text: 'Buyer Name',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
					hide: this.hideSpCols,
				}, {
					value: 'buyer_email',
					text: 'Buyer Email',
					class: 'black-lighten --text',
					width: 180,
					align: 'left',
					hide: this.hideSpCols,
				}, {
					value: 'ticketholder_name',
					text: 'Ticket Holder Name',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
					hide: this.hideSpCols,
				}, {
					value: 'ticketholder_dob',
					text: 'Ticket Holder Birthdate',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
				}, {
					value: 'ticket_identifier',
					text: 'Ticket Identifier',
					class: 'black-lighten --text',
					width: 125,
					align: 'left',
				}, {
					value: 'product_name',
					text: 'Product Name',
					class: 'black-lighten --text',
					width: 350,
					align: 'left',
				}, {
					value: 'product_sku',
					text: 'Product SKU',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
				}, {
					value: 'serviceprovider_name',
					text: 'Service provider',
					class: 'black-lighten --text',
					width: 180,
					align: 'left',
				}, {
					value: 'increment_id',
					text: 'Order ID',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
				}, {
					value: 'item_price',
					text: 'Item Price',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
				}, {
					value: 'base_price',
					text: 'Original Price',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
				}, {
					value: 'status_sales_flat_order',
					text: 'Order Status',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
				}, {
					value: 'created_at_sales_flat_order',
					text: 'Order Date',
					class: 'black-lighten --text',
					align: 'left',
					width: 150,
					formatter: (x) => (x ? moment(x).format(this.dateFormat) : null),
				}, {
					value: 'generic_usage_key',
					text: 'Generic usage key',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
					hide: this.hideGenericUsageKeyCol,
					formatter: (x) => (x !== null ? x : '-'),
				},
			],
			headersExpandedTable:
			[
				{
					value: 'usage_date',
					text: 'Redemption date and time',
					align: 'left',
					width: 150,
					formatter: (x) => (x ? moment.parseZone(x).format(this.dateFormat) : null),
				}, {
					value: 'original_contingent',
					text: 'Original Contingent',
					width: 125,
					align: 'left',
				},
				{
					value: 'remaining_contingent',
					text: 'Remaining contingent',
					width: 125,
					align: 'left',
				}, {
					value: 'validity_start_date',
					text: 'Validity Start Date',
					align: 'left',
					width: 140,
					formatter: (x) => (x ? moment(x).format(this.dateFormat) : null),
				}, {
					value: 'validity_end_date',
					text: 'Validity End Date',
					align: 'left',
					width: 140,
					formatter: (x) => (x ? moment(x).format(this.dateFormat) : null),
				}, {
					value: 'gate_group',
					text: 'Gate Group',
					align: 'left',
					width: 125,
				}, {
					value: 'gate',
					text: 'Gate',
					align: 'left',
					width: 115,
				}, {
					value: 'buyer_name',
					text: 'Buyer Name',
					align: 'left',
					width: 150,
					hide: this.hideSpCols,
				}, {
					value: 'buyer_email',
					text: 'Buyer Email',
					class: 'black-lighten --text',
					align: 'left',
					width: 180,
					hide: this.hideSpCols,
				}, {
					value: 'ticketholder_name',
					text: 'Ticket Holder Name',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
					hide: this.hideSpCols,
				}, {
					value: 'ticketholder_dob',
					text: 'Ticket Holder Birthdate',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
				}, {
					value: 'ticket_identifier',
					text: 'Ticket Identifier',
					align: 'left',
					width: 125,
				}, {
					value: 'product_name',
					text: 'Product Name',
					align: 'left',
					width: 350,
				}, {
					value: 'product_sku',
					text: 'Product SKU',
					align: 'left',
					width: 150,
				}, {
					value: 'serviceprovider_name',
					text: 'Service provider',
					align: 'left',
					width: 180,
				}, {
					value: 'increment_id',
					text: 'Order ID',
					align: 'left',
					width: 150,
				}, {
					value: 'item_price',
					text: 'Item Price',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
				}, {
					value: 'base_price',
					text: 'Original Price',
					class: 'black-lighten --text',
					width: 150,
					align: 'left',
				}, {
					value: 'status_sales_flat_order',
					text: 'Order Status',
					align: 'left',
					width: 150,
				}, {
					value: 'created_at_sales_flat_order',
					text: 'Order Date',
					align: 'left',
					width: 150,
					formatter: (x) => (x ? moment(x).format(this.dateFormat) : null),
				}, {
					value: 'generic_usage_key',
					text: 'Generic usage key',
					width: 150,
					align: 'left',
					hide: this.hideGenericUsageKeyCol,
					formatter: (x) => (x !== null ? x : '-'),
				},
			],
			expanded: [],
			details: [],
			options: {
				page: 1,
				itemsPerPage: 100,
				sortBy: ['usage_date'],
				sortDesc: [true],
				groupBy: [],
				groupDesc: [],
				mustSort: false,
				multiSort: false,
			},
			sortBy: 'usage_date',
			sortDesc: true,
			txt: {
				notProvided: 'info is not provided',
			},
			searchLocal: this.search,
			hideColsForSp: ['buyer_email', 'buyer_name', 'ticketholder_name'],
		}
	},
	watch: {
		expanded: {
			async handler() {
				this.expanded = this.details
			},
		},
		options: {
			handler() {
				if (this.doneFirstFetching == true) this.getDataFromApi()
			},
			deep: true,
		},
	},
	computed: {
		lastVcDataUpdateForMandatorLocal() {
			let returnValue = ''
			if (this.lastVcDataUpdateForMandator && this.lastVcDataUpdateForMandator != '') {
				returnValue = this.lastVcDataUpdateForMandator
			} else {
				returnValue = this.txt.notProvided
			}
			return returnValue
		},
		computedHeaders() {
			const filterdHeaders = []
			const hideColsGeneral = []
			if (this.hideSpCols) hideColsGeneral.push('buyer_email', 'buyer_name', 'ticketholder_name')
			if (this.hideGenericUsageKeyCol) hideColsGeneral.push('generic_usage_key')

			this.headers.forEach((header) => {
				if (!hideColsGeneral.includes(header.value)) {
					filterdHeaders.push(header)
				}
			})

			return filterdHeaders
		},
		computedExpandedHeaders() {
			const filterdExpandedHeaders = []
			const hideColsGeneral = []
			if (this.hideSpCols) hideColsGeneral.push('buyer_email', 'buyer_name', 'ticketholder_name')
			if (this.hideGenericUsageKeyCol) hideColsGeneral.push('generic_usage_key')

			this.headersExpandedTable.forEach((header) => {
				if (!hideColsGeneral.includes(header.value)) {
					filterdExpandedHeaders.push(header)
				}
			})

			return filterdExpandedHeaders
		},
	},
	methods: {
		async clickedRow(value) {
			if (this.expanded.map((x) => x.id).includes(value.id)) {
				this.$data.expanded = []
				this.$data.details = []
				// eslint-disable-next-line no-useless-return
				return
			}
			try {
				// eslint-disable-next-line max-len, no-undef
				const res = await axios.get(`${config.baseAPIurl}/validity-checker/row-details?installationId=${value.installation_id}&ticketId=${value.ticket_id}`)
				// eslint-disable-next-line prefer-const
				for (let row of res.data) {
					const uniqueIdRow = Object.values(row).join('?')
					if (row.id != value.id) row.id = uniqueIdRow
					// eslint-disable-next-line dot-notation
					row['unique_identifier'] = uniqueIdRow
				}
				this.details = res.data
				this.$data.expanded = [value]
			} catch (err) {
				console.log(err)
			}
		},
		getDataFromApi() {
			this.$emit('sortHasChanged', this.options)
		},
		getDataFromApiSearch() {
			setTimeout(this.emitFunc, 2000)
		},
		emitFunc() {
			this.$emit('update:search', this.searchLocal)
		},
	},
}
</script>

<style>
.validityCheckerDataTable{
	background-color: rgba(0, 159, 227, 0.8) !important;
}

.expandableArea{
	padding-left: 0px !important;
	padding-right: 0px !important;
	padding-bottom: 5px !important;
	padding-top: 5px !important;
	background-color:rgba(153, 149, 149, 0.2);
}

</style>
